import { getToken } from '@/axios'

export default {
  isUserLoggedIn: () => {
    return getToken() && localStorage.getItem('userData')
  }
}
